import '!style-loader!css-loader!../../css/base.css'
import '!style-loader!css-loader!../../css/timeline.css'
import '!style-loader!css-loader!../../css/react-contextmenu.css'
import '!style-loader!css-loader!../../css/corner-ribbon.css'
import '!style-loader!css-loader!../../css/typography.css'
import '!style-loader!css-loader!../../css/css-sprites-sort.css'
require('../globals.js')

// // CSS IMPORTS
// import '../../css/base.css'
// import '../../css/timeline.css'
// import '../../css/react-contextmenu.css'
// import '../../css/corner-ribbon.css'
// import '../../css/typography.css'
// import '../../css/css-sprites-sort.css'

// // JS IMPORTS
// import '../globals.js'